import React from "react";
import { SimManager } from "@learningblocks/simulation-engine";
import { FullscreenModal } from "@learningblocks/storybook-components";

import styles from "./RestartSkipped.module.scss";
import ProtocolOverviewIcon from "./images/RestartStep-icon.svg";

export interface RestartSkippedProps {
  close: (restoredSnapshot: boolean) => void;
  stepId: string;
}

export class RestartSkipped extends React.Component<RestartSkippedProps> {
  constructor(props: RestartSkippedProps) {
    super(props);
  }

  noClicked = () => {
    this.props.close(false);
  };

  yesClicked = () => {
    SimManager.getInstance().applyRestartSnapshot(this.props.stepId);
    this.props.close(true);
  };

  render() {
    return (
      <FullscreenModal
        className="modalContainer"
        isOpen={true}
        closeButton={false}
        notebookExpanded={false}
        close={this.noClicked}
        backLabel={"Lab"}
      >
        <div className={styles.Question}>
          <div className={styles.containerProtocolOverview}>
            <div
              className={`${styles["modal-section"]} ${styles["level-choice"]}`}
            >
              <img
                src={ProtocolOverviewIcon}
                style={{ height: "135px" }}
                alt="Protocol Overview icon"
              />
              <h4
                className={styles.restartModalHeading}
                aria-label={"Are you sure you want to undo this step?"}
              >
                Do you want to restart step?
              </h4>
              <p
                className={styles.restartsLeftText}
                aria-label={"1 restarts left"}
              >
                If you click "Restart step" you will have to redo all steps from{" "}
                {this.props.stepId}.
              </p>
              <div className={styles["modal-footer"]}>
                <button
                  aria-label={"No"}
                  tabIndex={0}
                  className={`${styles["modal-btn-secondary"]} ${styles["lvl-choice"]}`}
                  onClick={this.noClicked}
                >
                  Continue
                </button>
                <button
                  aria-label={"Yes"}
                  tabIndex={0}
                  className={`${styles["modal-btn-primary"]} ${styles["lvl-choice"]}`}
                  onClick={this.yesClicked}
                >
                  Restart step
                </button>
              </div>
            </div>
          </div>
        </div>
      </FullscreenModal>
    );
  }
}

export default RestartSkipped;
